import { atom } from "jotai";

// Atom to store the current height of the global banners
export const globalBannersHeightAtom = atom<number>(0);
